import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { getRolesRequest } from '../api/roleApi'
import { getRolesAction } from '../redux/actions/roleActions'

export const useRoleApi = () => {
  const dispatch = useDispatch()

  const getRoles = useCallback(async (id: Number | null) => {
    await getRolesRequest(id)
      .then(response => {
        dispatch(getRolesAction(response.data))
      })
      .catch(error => {
        console.error(error)
      })
  }, [])

  return {
    getRoles,
  }
}
